import PageHeader from './PageHeader';

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/Page/PageHeader/index.tsx